import { createContext, useContext, useMemo } from 'react';

import { createHitClickEvent } from '../../services/algolia';
import { useVendor } from '../VendorPovider/VendorPovider';
import api from '../../services/api';

import type { FC } from 'react';

interface AlgoliaAnalyticsContextProps {
  trackHitClick: (payload: { objectID: string }) => void;
}

const AlgoliaAnalyticsContext = createContext<AlgoliaAnalyticsContextProps>(
  undefined!
);

interface AlgoliaAnalyticsProps {
  indexName: string;
  queryID: string;
}

export const AlgoliaAnalytics: FC<AlgoliaAnalyticsProps> = ({
  indexName,
  queryID,
  children,
}) => {
  const { vendor } = useVendor();

  const state = useMemo(() => {
    return {
      trackHitClick: (payload) => {
        api.search.sendEvents({
          vendor,
          events: [createHitClickEvent({ ...payload, indexName, queryID })],
        });
      },
    } as AlgoliaAnalyticsContextProps;
  }, [indexName, queryID, vendor]);

  return (
    <AlgoliaAnalyticsContext.Provider value={state}>
      {children}
    </AlgoliaAnalyticsContext.Provider>
  );
};

const fallback: AlgoliaAnalyticsContextProps = {
  trackHitClick: () => {},
};

export const useAlgoliaAnalytics = () =>
  useContext(AlgoliaAnalyticsContext) ?? fallback;
